import { FilterField, useSubdivisionOptions } from "~/features/filter";
import {
  ViolationStatusType,
  ViolationTypeCategory,
} from "~/schemas/generated/graphql";

type Translate = (key: string) => string;

export const violationFilterFields = (t: Translate): FilterField[] => [
  {
    name: "searchText",
    type: "input",
    label: t("violation.name"),
  },
  {
    name: "fullname",
    type: "select",
    label: t("violation.changeStatus"),
    options: Object.keys(ViolationStatusType)
      .filter((item) => item !== "Deleted")
      .map((item) => ({
        value: item,
        label: t(`violation.${item}`),
      })),
  },
  {
    name: "event",
    type: "select",
    label: t("violation.SubdivisionId"),
    optionsHook: useSubdivisionOptions,
  },
  {
    name: "searchTextForSelect",
    type: "select",
    label: t("violation.category"),
    options: Object.keys(ViolationTypeCategory).map((item) => ({
      value: item,
      label: t(`violation.${item}`),
    })),
  },
];
